<template>
  <div id="contenedor-eliminar-contrato-programa">
    <v-card>
      <v-card-title>
        Eliminar Programa
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        ¿Desea eliminar <b>todo</b> el  <b>Programa</b>?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarTodoPrograma"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixProgramaContrato from './mixProgramaContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarContratoPrograma',
  mixins: [mixProgramaContrato],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    idPrograma: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
